module.exports = __webpack_public_path__ + "static/media/campus_26.9ed28be4.png";